<template>
  <div class="customer-page">
    <customer-header :name="nameRestaurant" back allergens @allergens="dialogAlergenos = true" />
    <main class="customer-content">
      <h1 class="page-title">{{ pageTitle }}</h1>
      <el-input v-model="search" placeholder="Buscar un plato" aria-label="Buscar un plato" clearable prefix-icon="el-icon-search" class="customer-search" />
      <p v-if="loading" class="customer-state" role="status">Cargando platos…</p>
      <div v-else-if="error" class="customer-state" role="alert">{{ error }} <el-button class="customer-retry" icon="el-icon-refresh" @click="loadData">Reintentar</el-button></div>
      <template v-else>
        <div v-if="groupId && visibleGroups.length" class="dish-grid">
          <dish-card v-for="dish in visibleGroups[0].plu" :key="dish.key" :dish="dish" :allergens="alergenos" />
        </div>
        <el-collapse v-else-if="!groupId" v-model="openedGroups" class="customer-collapse">
          <el-collapse-item v-for="group in visibleGroups" :key="group.id || group.key" :name="group.id || group.key">
            <template slot="title"><div class="category-heading"><img v-if="group.iconImage || iconos[group.icon]" :src="group.iconImage ? apiImage(group.iconImage) : iconos[group.icon].url" alt="" /><span>{{ group.group }}</span></div></template>
            <div class="dish-grid"><dish-card v-for="dish in group.plu" :key="dish.key" :dish="dish" :allergens="alergenos" /></div>
            <p v-if="!group.plu.length" class="customer-state">No hay platos disponibles en esta familia.</p>
          </el-collapse-item>
        </el-collapse>
        <p v-if="!visibleGroups.length" class="customer-state">{{ groupId && !selectedGroup ? 'Este grupo ya no está disponible.' : 'No hay platos que coincidan con la búsqueda.' }}</p>
      </template>
    </main>
    <allergen-dialog v-model="dialogAlergenos" :allergens="alergenos" />
  </div>
</template>
<script>
import * as api from "../api/request";
import CustomerHeader from "../components/CustomerHeader.vue";
import DishCard from "../components/DishCard.vue";
import AllergenDialog from "../components/AllergenDialog.vue";
export default {
  components: { CustomerHeader, DishCard, AllergenDialog },
  props: { groupId: { type: String, default: "" } },
  data() { return { nameRestaurant: "", logo: "", data: [], alergenos: [], iconos: [], dialogAlergenos: false, search: "", activeGroups: [], loading: true, error: "", enableCarta: false }; },
  computed: {
    selectedGroup() { return this.data.find(group => String(group.id || group.key) === this.groupId && group.enable === true && group.showOnHome === true); },
    pageTitle() { return this.groupId && this.selectedGroup ? this.selectedGroup.group : "Carta"; },
    visibleGroups() {
      const normalize = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const query = normalize(this.search).trim();
      const groups = this.groupId ? (this.selectedGroup ? [this.selectedGroup] : []) : (this.enableCarta ? this.data.filter(group => group.enable === true) : []);
      return groups.map(group => ({ ...group, plu: (group.plu || []).filter(dish => dish.enable === true &&
        (!query || normalize(group.group + " " + dish.name + " " + (dish.descripcion || "")).includes(query))) }))
        .filter(group => !query || group.plu.length);
    },
    openedGroups: {
      get() { return this.search.trim() ? this.visibleGroups.map(group => group.id || group.key) : this.activeGroups; },
      set(value) { this.activeGroups = value; }
    }
  },
  mounted() { this.loadData(); },
  watch: { groupId() { this.search = ""; this.activeGroups = []; } },
  methods: {
    apiImage: api.imageUrl,
    async loadData() {
      this.loading = true; this.error = "";
      try {
        const data = await api.carta();
        this.nameRestaurant = data.nameRestaurant;
        this.logo = api.imageUrl(data.logo);
        this.data = data.data || [];
        this.enableCarta = data.enableCarta === true;
        const [allergens, icons] = await Promise.all([api.getAlergenos(), api.getIconos()]);
        this.alergenos = allergens; this.iconos = icons;
      } catch (error) { this.error = "No se pudieron cargar los platos. Comprueba tu conexión."; }
      finally { this.loading = false; }
    }
  }
};
</script>
